import { render, staticRenderFns } from "./com-page-index.vue?vue&type=template&id=77e6311b&"
import script from "./com-page-index.vue?vue&type=script&lang=js&"
export * from "./com-page-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports